module.exports = __webpack_public_path__ + "static/part-2-c4b76540cf4625012fc735749de9c9f4.svg";